<app-menu></app-menu>
<app-login-validation (loggedIn)="onLoginValidated($event)"></app-login-validation>

<div class="page">
  <div class="container">
    <h1>Meus livros</h1>

    <!-- métricas -->
    <div class="cards">
      <div class="card">
        <div class="card-title">Quantidade de livros vendidos</div>
        <div class="card-value">{{ totalBooksSold }}</div>
      </div>

      <div class="card">
        <div class="card-title">Receita total (bruto)</div>
        <div class="card-value">
          {{ totalGrossRevenue | currency:'BRL':'symbol':'1.2-2' }}
        </div>
      </div>

      <div class="card">
        <div class="card-title">Receita na minha carteira</div>
        <div class="card-value">
          {{ walletAvailable | currency:'BRL':'symbol':'1.2-2' }}
        </div>
      </div>
    </div>

    <ng-container *ngIf="isLoading; else listTpl">
      <div class="spinner">
        <mat-progress-spinner mode="indeterminate" diameter="56"></mat-progress-spinner>
      </div>
    </ng-container>

    <ng-template #listTpl>
      <!-- header da lista -->
      <div class="list-header">
        <div class="col cover">Capa</div>
        <div class="col title">Título</div>
        <div class="col status">Status</div>
        <div class="col date">Data</div>
        <div class="col items">Itens à venda</div>
        <div class="col actions">Ações</div>
      </div>

      <!-- itens -->
      <div class="group" *ngFor="let item of list; trackBy: trackByBook">
        <div class="version" *ngFor="let v of item.versions; trackBy: trackByVersion">
          <div class="col cover">
            <img
              [src]="v.coverUrl"
              alt="Capa do livro"
            />
          </div>

          <div class="col title">
            <div class="title-text" [class.group-header]="v.isGroupHeader">{{ v.title }}</div>
            <div class="subtitle" *ngIf="!v.isGroupHeader && item.versions.length > 1">
              Versão adicional
            </div>
          </div>

          <div class="col status">
            <span class="chip"
                  [ngClass]="{
                    'chip-published': (v.status || '').toLowerCase().includes('publica'),
                    'chip-review': (v.status || '').toLowerCase().includes('revis'),
                    'chip-pending-approval': (v.status || '').toLowerCase().includes('aprova'),
                    'chip-payment': (v.status || '').toLowerCase().includes('pagamento'),
                    'chip-paused': (v.status || '').toLowerCase().includes('pausad'),
                    'chip-rejected': (v.status || '').toLowerCase().includes('reprov'),
                    'chip-edit': !(v.status || '')
                  }"
                  [matTooltip]="v.statusTooltip">
              {{ v.status }}
            </span>
          </div>

          <div class="col date">
            {{ v.date }}
          </div>

          <div class="col items">
            <ng-container *ngIf="v.itemsForSale?.length; else naTpl">
              {{ v.itemsForSale.join(', ') }}
            </ng-container>
            <ng-template #naTpl> N/A </ng-template>
          </div>

          <div class="col actions">
            <button mat-icon-button aria-label="Editar"
                    (click)="goTo(v.actions.editUrl)"
                    [matTooltip]="'Editar'">
              <mat-icon style="color: rgb(12, 114, 12);">edit</mat-icon>
            </button>

            <button mat-icon-button aria-label="Métricas"
                    (click)="goTo(v.actions.toggleSalesUrl)"
                    [matTooltip]="'Métricas'">
              <mat-icon *ngIf="(v.status || '').toLowerCase().includes('publica')" style="color: rgb(126, 107, 4);">equalizer</mat-icon>
            </button>

            <!-- <button mat-icon-button aria-label="Pausar/Retomar"
                    (click)="goTo(v.actions.toggleSalesUrl)"
                    [matTooltip]="v.actions?.toggleSalesTooltip || 'Pausar/Retomar vendas'">
              <mat-icon>equalizer</mat-icon>
            </button> -->
          </div>
        </div>
      </div>

      <div *ngIf="!list?.length" class="empty">
        Você ainda não possui livros. Comece criando um <a routerLink="/novo-livro">novo livro</a>.
      </div>
    </ng-template>
  </div>
</div>

<app-footer></app-footer>